export const Footer = () => {
  return (
    <div className="footer-div">
      <div className="footer-wrap">
        <div className="footer-grid">
          <div className="co-name">
            <h1>BUDS FAM & CO.</h1>
          </div>
        </div>

        <div className="lower-div">
          <hr />
          <span>
            © 2023 Buds Fam & Co., Inc. | A member of the Legitimate Business,
            Inc. family. | All Rights Reserved.
          </span>
        </div>
      </div>
    </div>
  );
};
